// userApi.js
import { sendRequest } from '@/common/sendRequest';

const userApi = {
  /**
   * 회원가입
   */
  async signup(data) {
    // 서버에서 SUCCESS면 그대로 반환, FAILURE/ERROR면 throw
    return sendRequest('/api/public/user/signup', {
      method: 'POST',
      data,
    });
  },

  /**
   * 비밀번호 재설정
   */
  async resetPassword(data) {
    return sendRequest('/api/public/user/resetPassword', {
      method: 'POST',
      data,
    });
  },

  /**
   * 인증 코드 요청
   */
  async reqcode(data) {
    return sendRequest('/api/public/user/reqcode', {
      method: 'POST',
      data,
    });
  },

  /**
   * 인증 확인
   */
  async verify(data) {
    return sendRequest('/api/public/user/verify', {
      method: 'POST',
      data,
    });
  },
};

export default userApi;
